import { useLocation } from 'react-router';

const useUrlSearchParams = () => {
  const searchParams = {};

  const location = useLocation();

  new URLSearchParams(location.search).forEach((value, key) => (searchParams[key] = value));

  return searchParams;
};

export default useUrlSearchParams;
